import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const BellGlyph = /*#__PURE__*/createElement("g", {
  id: "bell",
  transform: "scale(3.5)",
  fill: "none"
}, /*#__PURE__*/createElement("path", {
  d: "M10 4C5.6 4 2 7.6 2 12V18.5C2 19.3 1.3 20 0.5 20H19.5C18.7 20 18 19.3 18 18.5V12C18 7.6 14.4 4 10 4ZM10 4V1M12.4 22C12.2 23.2 11.1 24 10 24C8.80001 24 7.80001 23.2 7.60001 22M12.5 7.5C14 8.2 15 9.8 15 11.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
const Bell = createSvg({
  name: 'bell',
  path: BellGlyph
});

export default Bell;
export { BellGlyph };
